module.exports = "/images/download-icon@3x.png?935de4400fb14160124c36129e819743";